import React from 'react';

const SuccessScreen = ({ contact, downloadApp, onReturnToMain }) => {
    const handleDownloadClick = () => {
        console.log('Download button clicked in success screen');
        console.log('downloadApp function:', downloadApp);

        if (downloadApp && typeof downloadApp === 'function') {
            downloadApp();
        } else {
            console.error('downloadApp function not available in success screen');
        }
    };

    return (
        <div className="success-screen">
            <div className="success-content">
                <div className="success-badge">
                    <img src="assets/images/icons/check_icon.png" alt="Success" />
                </div>
                <div className="success-text">Sent</div>
                <div className="success-actions">
                    <button className="download-pov-btn" onClick={handleDownloadClick}>
                        Download POV
                    </button>
                    <button className="success-subtitle" onClick={onReturnToMain}>
                        Send {contact.name} another POV
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessScreen;